<template>
  <div>
    <div class="ticker-flex-generic">
      <span :class="tickerClass">{{ params.ticker }}</span>
      <span v-if="params.node.allChildrenCount && accessibilityFeatures" class="sr-only">{{ params.groupSRText }}</span>
    </div>
    <c-halt-indicator :tradeHaltValue="tradeHaltValue" :toolTipRequired="false" />
  </div>
</template>

<script>
import CHaltIndicator from '@custom/CHaltIndicator';

export default {
  name: 'ticker-renderer',
  components: {
    CHaltIndicator
  },
  computed: {
    tradeHaltValue() {
      return this.params.tradeHaltValue;
    },
    tickerClass() {
      if (this.params.priceChange) {
        if (this.params.priceChange > 0) return 'positive';
        else if (this.params.priceChange < 0) return 'negative';
      } else return '';
    },
    accessibilityFeatures() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  },
  methods: {
    refresh(params) {
      this.params = params;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.ticker-flex-generic {
  display: flex;
  flex-flow: row nowrap;
  display: inline;
  .positive {
    color: $positive-text;
  }
  .negative {
    color: $negative-text;
  }
}
</style>
